import { get, put, post } from '../request';

export async function fetchLoginSettings(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/configuration/loginsettings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateLoginSettings(
  { taxingUnitService },
  authenticationToken,
  { payload },
) {
  const url = `${taxingUnitService}/taxingunit/configuration/loginsettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchChartType(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/configuration/charttype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchChartSettings(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/configuration/chartsettings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateChartSettings(
  { taxingUnitService },
  authenticationToken,
  { payload },
) {
  const url = `${taxingUnitService}/taxingunit/configuration/chartsettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchStatusSettings(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/configuration/status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateStatusSettings(
  { taxingUnitService },
  authenticationToken,
  { payload },
) {
  const url = `${taxingUnitService}/taxingunit/configuration/status`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function searchTaxpayerNotificationsEmails(
  { taxingUnitService },
  authenticationToken,
  { payload, page, pageSize },
) {
  const url = `${taxingUnitService}/taxingunit/taxpayernotifications/emails?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchNotificationRuns(
  { taxingUnitService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${taxingUnitService}/taxingunit/taxpayernotificationruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createNotificationRun(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/taxpayernotificationruns`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchNotificationRunRecords(
  { taxingUnitService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${taxingUnitService}/taxingunit/taxpayernotificationrun/${runID}/records?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchNotificationRunEmails(
  { taxingUnitService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${taxingUnitService}/taxingunit/taxpayernotificationrun/${runID}/emails?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}